import React, { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { getGuestPaymentLink } from './../../apis/services';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

export default function PaymentLinkGenerator() {
    const lang = localStorage.getItem('lang') || 'en';
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [amount, setAmount] = useState("");
    const [notes, setNotes] = useState("");
    const [paymentLink, setPaymentLink] = useState();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const toast = useRef();
    const validateForm = () => {
        const newErrors = {};
        if (!name.trim()) newErrors.name = t('Name is required');
        if (!phone.trim()) newErrors.phone = t("Phone is required");
        if (!amount.trim()) newErrors.amount = t("Amount is required");
        if (!notes.trim()) newErrors.notes = t("Notes is required");
        else if (isNaN(amount)) newErrors.amount = t("Amount must be a number");

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleGenerateLink = (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        getPaymentLink();
    };

    const getPaymentLink = async () => {
        try {
            setLoading(true);
            let data = {
                name: name,
                phone: phone,
                amount: amount,
                notes:notes,
                transaction:crypto.randomUUID(),
            }
            const res = await getGuestPaymentLink(data);
            setPaymentLink(res.data);
            setLoading(false);

        } catch (error) {
            setLoading(false);
            console.log(error);

        }
    }
    const updateAppLang = (newLang) => {
        localStorage.setItem('lang', newLang);
        window.location.reload();
    }
    return (
        <div className="container-fluid d-flex justify-content-center align-items-center vh-100 bg-light">
            <Toast ref={toast} />
            <div className="col-12 col-md-8 col-lg-6">

                <Card className="shadow">
                    <div className="d-flex jcsb">
                        <h5>{t('Generate_Payment_Link')}</h5>
                        <Link to=""
                            onClick={() => {
                                updateAppLang(lang === "en" ? 'ar' : 'en');
                            }}
                            className='m-2'>{lang === "en" ? 'عربي' : 'English'}</Link>
                    </div>
                    <div className="text-center m-4">
                        <img src="/assets/img/ncd.jpeg" height={100} width={100} />

                    </div>
                    {
                        paymentLink === undefined &&
                        <form onSubmit={handleGenerateLink} noValidate>
                            <div className="d-flex flex-column gap-3">
                                <div className="form-floating">
                                    <InputText
                                        id="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                    />
                                    <label htmlFor="name">{t('name')}</label>
                                    {errors.name && (
                                        <div className="invalid-feedback">{errors.name}</div>
                                    )}
                                </div>

                                <div className="form-floating">
                                    <InputText
                                        id="phone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        keyfilter="int"
                                        className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                                    />
                                    <label htmlFor="phone">{t('phone')}</label>
                                    {errors.phone && (
                                        <div className="invalid-feedback">{errors.phone}</div>
                                    )}
                                    <h6 className="mx-2 mt-2">{t('Please enter Phone number with country code to Share on WhatsApp')}.</h6>
                                </div>

                                <div className="form-floating">
                                    <InputText
                                        id="amount"
                                        value={amount}
                                        onChange={(e) => setAmount(e.target.value)}
                                        keyfilter="num"
                                        className={`form-control ${errors.amount ? "is-invalid" : ""}`}
                                    />
                                    <label htmlFor="amount">{t('Amount')}</label>
                                    {errors.amount && (
                                        <div className="invalid-feedback">{errors.amount}</div>
                                    )}
                                </div>

                                <div className="form-floating">
                                    <InputText
                                        id="notes"
                                        value={notes}
                                        onChange={(e) => setNotes(e.target.value)}
                                        className={`form-control ${errors.notes ? "is-invalid" : ""}`}
                                    />
                                    <label htmlFor="amonotesunt">{t('notes')}</label>
                                    {errors.amount && (
                                        <div className="invalid-feedback">{errors.notes}</div>
                                    )}
                                </div>


                                <Button
                                    type="submit"
                                    label={t('Generate Link')}
                                    loading={loading}
                                />
                                <Link to={'/payment-link/logs'}>Go To Logs</Link>
                            </div>
                        </form>
                    }
                    {
                        paymentLink !== undefined &&
                        <div className="text-center">
                            <h6 className="text-center">{t('Payment Link Generated Successfully')}</h6>
                            <div className="d-flex"
                                style={{
                                    justifyContent: "center"
                                }}
                            >
                                <Button label={t('Copy Link')} severity="info" className="mt-3 rounded-btn"
                                    onClick={() => {
                                        navigator.clipboard.writeText(paymentLink.url).then(() => {
                                            toast.current.show({ severity: 'success', summary: t('Copied'), detail: t("Payment Link Copied"), life: 3000 });
                                        });
                                    }}
                                />
                                <Button label={t("Share on WhatsApp")} className="mt-3 rounded-btn mx-2"
                                    onClick={() => {
                                        const message = `Hi ${name}, please complete your payment of KWD ${amount} using this link: ${paymentLink.url}`;
                                        const waLink = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
                                        window.open(waLink, "_blank");
                                    }}
                                />
                            </div>
                            <div className="mt-4">
                                <a href="/create/payment-link" className="link-btn mt-5">{t('Make new Link')}</a>
                            </div>
                        </div>
                    }
                </Card>
            </div>
        </div>
    );
}
